import React, { useEffect, useState } from 'react';
import Table from '../../../component/common/Table';
import Pagination from '../../../component/common/table2/Pagination';
import Loader from '../../../component/common/Loader';
import shuffle from '../../../assets/svg/icons/shuffle.svg';
import RightArrow from '../../../assets/images/RightArrow.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { GENDER } from '../../../utils/constants';
// import { Api } from '../../../api';
import { errorToast, successToast } from '../../../utils/helper';
import { ApiForRole } from '../challenges/ApiForRole';

const stepsList = [{ id: 1, name: 'Step Count', count: '3,075' }];
const sleepList = [{ id: 1, name: 'Sleep Count', count: '300' }];

const WinnerResult = ({ data, setData, handleChangeType }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(20);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [winnerList, setWinnerList] = useState([]);
  const [count, setCount] = useState({
     rewardStatus: 0,
    totalCompletedUsers: 0,
    totalRequestedWinners: 0,
    totalSelectedWinners: 0
  });
  const [loader, setLoader] = useState(false);

  const [selectedWinners, setSelectedWinners] = useState([]);
  const [maxWinners, setMaxWinners] = useState(0);
  // const [winnerAnnoucement, setWinnerAnnouncement] = useState(false);

  console.log(selectedWinners, 'selectedWinnersselectedWinnersselectedWinners');

  const toggleWinner = async (userId) => {
        if(count?.rewardStatus==9){
      errorToast('Winner selection is closed. Winners have already been announced');
      return;
    }
    const isAlreadySelected = selectedWinners.includes(userId);

    if (!isAlreadySelected && selectedWinners.length >= maxWinners) {
      errorToast(`You can only select up to ${maxWinners} winners.`);
      return;
    }

    const updatedWinners = isAlreadySelected
      ? selectedWinners.filter((id) => id !== userId)
      : [...selectedWinners, userId];

    setSelectedWinners(updatedWinners);

    // ✅ API call
    // try {
    //   const res = await axios.post('/api/winners/update', {
    //     userId,
    //     selected: !isAlreadySelected,
    //   });
    //   console.log('API Response:', res.data);
    // } catch (err) {
    //   console.error('API Error:', err);
    // }
  };

  const columns = [
    {
      title: 'Name',
      key: 'name',
      sortable: false,
      align: 'left',
      type: 'text'
    },
    {
      title: 'Gender',
      key: 'gender',
      sortable: false,
      align: 'left',
      type: 'text'
    },
    {
      title: 'Date',
      key: 'dateNew',
      sortable: false,
      align: 'center',
      type: 'text'
    },
    {
      title: 'Activity Count',
      key: 'email',
      sortable: false,
      align: 'center',
      type: 'text'
    },
    {
      title: 'Action',
      key: 'status',
      align: 'center',
      selectButton: 'Select as winner',
      type: 'action'
      // winnerAction: true,
    }
  ];

  const getGenderName = (value) => {
    const genderItem = GENDER.find((g) => g.value === value);
    return genderItem ? genderItem.name : 'Not specified'; // Default if not found
  };

  const handlePagination = async (pageNumber, pageSize, query) => {
    // setLoader(true);
    // const response = await ApiForRole().getWellpointTransactionData(pageNumber, pageSize, query);
    // if (response?.data?.meta?.code === 200) {
    //     setCurrentPage(pageNumber);
    //     setTotalCount(response?.data?.meta?.total);
    //     setLoader(false);
    // } else if (response?.code === 401) {
    //     setLoader(false);
    //     errorToast(response?.message);
    // } else if (response?.data?.meta?.code === 0) {
    //     setCurrentPage(1);
    //     setWellpointTransactionList([]);
    //     setTotalCount(0);
    //     setLoader(false);
    //     errorToast(response?.data?.meta?.message);
    // } else {
    //     setLoader(false);
    // }
  };
  const columnsSteps = [
    {
      title: 'Steps',
      key: 'name',
      sortable: false,
      align: 'left',
      type: 'text'
    },
    {
      title: '',
      key: 'count',
      sortable: false,
      align: 'center',
      type: 'text'
    }
  ];
  const columnsSleep = [
    {
      title: 'Sleep',
      key: 'name',
      sortable: false,
      align: 'left',
      type: 'text'
    },
    {
      title: '',
      key: 'count',
      sortable: false,
      align: 'center',
      type: 'text'
    }
  ];

  const fetchList = async (id) => {
    setLoader(true);
    try {
      const response = await ApiForRole().getWinnersList(id);
      const responseData = response?.data?.users || [];
      console.log(responseData, response?.data, 'fetch by id');

      if (response.status === 200) {
        // setTotalCount(response?.data?.meta?.total);
        // setData(responseData);
        setCount(
          response?.data?.summary || {
            rewardStatus: 0,
            totalCompletedUsers: 0,
            totalRequestedWinners: 0,
            totalSelectedWinners: 0
          }
        );
        setMaxWinners(response?.data?.summary?.totalRequestedWinners || 0);
        const modifiedData = responseData.map((item) => ({
          ...item,
          gender: item?.gender ? getGenderName(item.gender[0]) : 'N/A',
          dateNew: item?.date ? item.date : 'N/A'
        }));
        const preSelected = modifiedData
          ?.filter((item) => item.status === 'winner')
          ?.map((item) => item._id); // Or use a unique key

        setSelectedWinners(preSelected);
        setWinnerList(modifiedData || []);
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (state?._id) {
      fetchList(state?._id);
    }
  }, [state?._id]);

  const selectRandomWinner = async (id) => {
    if(count?.rewardStatus==9){
      errorToast('Winner selection is closed. Winners have already been announced');
      return;
    }
    setLoader(true);
    const body = {
      challengeId: id
    };
    try {
      const response = await ApiForRole().addRandomWinner(body);
      //   const responseData = response?.data?.winners || {};
      console.log(response?.data, 'fetch by id');

      if (response.status === 200) {
        // setTotalCount(response?.data?.meta?.total);
        // setData(responseData);
        successToast(response?.data?.message);
        fetchList(state?._id);
        // const modifiedData = responseData.map((item) => ({
        //   ...item,
        //   gender: item?.gender ? getGenderName(item?.gender?.[0]) : 'N/A'}));
        // setWinnerList(modifiedData || [])
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  };

  const ManualSelectWinners = async (id) => {

    setLoader(true);
    const body = {
      userIds: selectedWinners,
      challengeId: id
    };
    try {
      const response = await ApiForRole().addManualSelectWinners(body);
      //   const responseData = response?.data?.winners || {};
      console.log(response?.data, 'fetch by id');

      if (response.status === 200) {
        // setTotalCount(response?.data?.meta?.total);
        // setData(responseData);
        navigate('/challenges/create-new-challenges?page=email', {
          state: {
            _id: state?._id
          }
        });
        successToast(response?.data?.message);
        fetchList(state?._id);
        // const modifiedData = responseData.map((item) => ({
        //   ...item,
        //   gender: item?.gender ? getGenderName(item?.gender?.[0]) : 'N/A'}));
        // setWinnerList(modifiedData || [])
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  };
  console.log(count, winnerList, 'winnerListwinnerList');
  return (
    <div>
      {loader ? <Loader /> : null}
      <div className="flex flex-wrap md:flex-nowrap gap-[15px] w-full p-4">
        {/* Left Div */}
        <div
          className="
                flex-3 min-w-[200px] md:w-[75%] flex flex-col bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl"
        >
          <div className="flex-1 p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-medium text-xl">{`Select Winner (${selectedWinners?.length}/${count?.totalRequestedWinners})`}</h3>
              <div className="ml-3">
                <button
                  type="button"
                  onClick={() => selectRandomWinner(state?._id)}
                  className="inline-flex text-xs sm:text-base font-medium items-center justify-center 
                                    px-2 gap-2 h-[40px] rounded-full border border-[#4A56DB] bg-[#E5EAF9] text-[#4A56DB]"
                >
                  <img className="ml-2" src={shuffle} alt="" />
                  Random Pick
                </button>
              </div>
            </div>
            <Table
              columns={columns}
              data={winnerList}
              name={'winner_results'}
              bottomBorder={totalCount > 10}
              loader={loader}
              selectedWinners={selectedWinners}
              toggleWinner={toggleWinner}
            />
          </div>
        </div>

        {/* Right Div */}
        <div className="flex-1 min-w-[200px] md:w-[25%] flex flex-col bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
          <div className="flex-1 p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-medium text-xl">Wearable Info</h3>
            </div>
            <div className="flex-1">
              <Table
                columns={columnsSteps}
                data={stepsList}
                name={'steps_count'}
                bottomBorder={totalCount > 10}
                loader={loader}
              />
            </div>
            <div className="flex-1 mt-4">
              <Table
                columns={columnsSleep}
                data={sleepList}
                name={'sleep_count'}
                bottomBorder={totalCount > 10}
                loader={loader}
              />
            </div>
            <div className="flex-1 mt-4">
              <button
                type="button"
                ManualSelectWinners
                className="text-sm px-5 h-[40px] rounded-full border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
              >
                Select as Winner
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='mt-5'>
                {totalCount > recordsPerPage ? (
                    <Pagination
                        currentPage={currentPage}
                        totalCount={totalCount}
                        pageSize={recordsPerPage}
                        onPageChange={(page) =>
                            handlePagination(
                                page,
                                recordsPerPage,
                            )
                        }
                    />
                ) : (
                    <span />
                )}
            </div> */}
      <div className="flex justify-end mt-6">
        {
          <button
            // onClick={() => {
            //   navigate('/challenges/create-new-challenges?page=email', {
            //     state: {
            //       _id: state?._id
            //     }
            //   });
            // }}
            onClick={() => ManualSelectWinners(state?._id)}
            type="button"
            className="inline-flex text-xs sm:text-base font-medium items-center justify-center rounded-3xl border bg-shoorah-secondary px-5 py-2 text-white hover:shoorah-primary focus:outline-none w-full sm:w-auto"
          >
            Email Notification
            <img className="ml-2" src={RightArrow} alt="edit" />
          </button>
        }
      </div>
    </div>
  );
};

export default WinnerResult;